export const UPLOAD_NOTICE_RESULTS_REQUEST = 'UPLOAD_NOTICE_RESULTS_REQUEST';

export const uploadNoticeResultsRequest = ( formData ) => ({
    type: UPLOAD_NOTICE_RESULTS_REQUEST,
    payload: { formData }
});
